import React, { useState, useEffect } from "react"
import CustomTextField from '../../StandardComponents/CustomTextField';

import {CONST_ERROR, CONST_SUCCESS, CONST_PAYMENT_INSTRUCTIONS} from '../../../constants/string'
import * as database from '../../../constants/database'
import * as localstorage from '../../../constants/localstorage'




import { makeStyles } from '@material-ui/core/styles';
import { db } from "../../../firebase"
import { useAuth } from "../../../contexts/AuthContext"

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';

import { Typography } from "@material-ui/core";
import GeneralViewContainer from "../../StandardComponents/GeneralViewContainer";

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
  },
  snack: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  progressbar: {
    position: 'absolute',
    zIndex : '1000',
    width: '10%',
    height: '100%',
  }

  
}));



function notEmpty(val){
  if(val)
  {
    return true;
  }
  return false;
}



var invoicePaymentInstructionsEmailBefore = "";
var invoicePaymentInstructionsEmailLive = "";

var invoicePaymentInstructionsChequesPayableBefore = "";
var invoicePaymentInstructionsChequesPayableLive = "";

var invoicePaymentInstructionsBankTransferBefore = "";
var invoicePaymentInstructionsBankTransferLive = "";

var invoicePaymentInstructionsOtherBefore = "";
var invoicePaymentInstructionsOtherLive = "";




export default function PaymentInstructions(props) {



  const { currentUser } = useAuth()

  var userRef = db.collection("users").doc(currentUser.uid);
  var documentsRecordsRef = userRef.collection(database.TABLE_NAME_INVOICES);


  var specificItemRef;

  function setQuery(){

    var docId = localStorage.getItem(localstorage.CONST_LOCALSTORAGE_DOCUMENTID);
    if(!docId)
    {
       props.startSnackBar(true, 20000,CONST_ERROR.NO_CONTACT_PROVIDED,"error",true)
        return;
    }
    specificItemRef = documentsRecordsRef.doc(docId);
    
  }


  var [loading, setLoading] = useState(false)


  const [invoicePaymentInstructionsEmail, setinvoicePaymentInstructionsEmail] = useState("")

  const [invoicePaymentInstructionsChequesPayable, setinvoicePaymentInstructionsChequesPayable] = useState("")

  const [invoicePaymentInstructionsBankTransfer, setinvoicePaymentInstructionsBankTransfer] = useState("")

  const [invoicePaymentInstructionsOther, setinvoicePaymentInstructionsOther] = useState("")






  const [open, setOpen] = React.useState(false);
  const openDialog = () => {
    setOpen(true);
  };

  const closeDialog = () => {
    setOpen(false);
  };




  

  async function writeUserData() {


    setLoading(true)
    return specificItemRef.set({
    
      [database.COLUMN_NAME_INVOICE_PAYMENTINSTRUCTIONSEMAIL]: invoicePaymentInstructionsEmail,
      [database.COLUMN_NAME_INVOICE_PAYMENTINSTRUCTIONSECHEQUESPAYABLE]: invoicePaymentInstructionsChequesPayable,
      [database.COLUMN_NAME_INVOICE_PAYMENTINSTRUCTIONSBANKTRANSFER]: invoicePaymentInstructionsBankTransfer,
      [database.COLUMN_NAME_INVOICE_PAYMENTINSTRUCTIONSOTHER]: invoicePaymentInstructionsOther
    },{ merge: true })
    .then(() => {
      setLoading(false)
      setError("")

      
      props.setSaveState(false);

      props.startSnackBar(true, 2000,CONST_SUCCESS.SAVED,"success",true)

      invoicePaymentInstructionsEmailBefore = invoicePaymentInstructionsEmailLive
      invoicePaymentInstructionsChequesPayableBefore = invoicePaymentInstructionsChequesPayableLive
      invoicePaymentInstructionsBankTransferBefore = invoicePaymentInstructionsBankTransferLive
      invoicePaymentInstructionsOtherBefore = invoicePaymentInstructionsOtherLive
  })
  .catch((error) => {
      props.startSnackBar(true, 20000,CONST_ERROR.FAILED_TO_GET_DATA+" "+error.code,"error",true)

      setLoading(false)
  });
  }







  const fetchData=async()=>{
  return specificItemRef.get().then((doc) => {
    if (doc.exists) {
        var invoicePaymentInstructionsEmail = doc.data()[database.COLUMN_NAME_INVOICE_PAYMENTINSTRUCTIONSEMAIL]
        var invoicePaymentInstructionsChequesPayable = doc.data()[database.COLUMN_NAME_INVOICE_PAYMENTINSTRUCTIONSECHEQUESPAYABLE]
        var invoicePaymentInstructionsBankTransfer = doc.data()[database.COLUMN_NAME_INVOICE_PAYMENTINSTRUCTIONSBANKTRANSFER]
        var invoicePaymentInstructionsOther = doc.data()[database.COLUMN_NAME_INVOICE_PAYMENTINSTRUCTIONSOTHER]
 

        if(invoicePaymentInstructionsEmail)
        {
          setinvoicePaymentInstructionsEmail(invoicePaymentInstructionsEmail);
          invoicePaymentInstructionsEmailBefore = invoicePaymentInstructionsEmail;
          invoicePaymentInstructionsEmailLive = invoicePaymentInstructionsEmail;
        }
        if(invoicePaymentInstructionsChequesPayable)
        {
          setinvoicePaymentInstructionsChequesPayable(invoicePaymentInstructionsChequesPayable);
          invoicePaymentInstructionsChequesPayableBefore = invoicePaymentInstructionsChequesPayable;
          invoicePaymentInstructionsChequesPayableLive = invoicePaymentInstructionsChequesPayable;
        }
        if(invoicePaymentInstructionsBankTransfer)
        {
          setinvoicePaymentInstructionsBankTransfer(invoicePaymentInstructionsBankTransfer);
          invoicePaymentInstructionsBankTransferBefore = invoicePaymentInstructionsBankTransfer;
          invoicePaymentInstructionsBankTransferLive = invoicePaymentInstructionsBankTransfer;
        }
        if(invoicePaymentInstructionsOther)
        {
          setinvoicePaymentInstructionsOther(invoicePaymentInstructionsOther);
          invoicePaymentInstructionsOtherBefore = invoicePaymentInstructionsOther;
          invoicePaymentInstructionsOtherLive = invoicePaymentInstructionsOther;
        }


       

    } else {
      props.startSnackBar(true, 20000,CONST_ERROR.NO_SUCH_DATA,"error",true)

    }
}).catch((error) => {
  props.startSnackBar(true, 20000,CONST_ERROR.PROBLEM_GETTING_DATA+" "+error.code,"error",true)

});

}



useEffect(async () => {
  props.handleLoadingState(loading)
}, [loading])


useEffect(async () => {
  
  if(props.activateSave)
  {
    handleSaveData()
  }

}, [props.activateSave])


useEffect(async () => {
  // Update the document title using the browser API
  props.pageDisplayStatus((pageState) => ({...pageState, backButton:true, mainTab:false, invoiceEstimateTab:false, edPrHiTab: false}))

  setLoading(true)
  
try{
  setError("")
  setQuery()
  fetchData();
  props.setSaveState(false);
}
catch(error){
  props.startSnackBar(true, 20000,CONST_ERROR.FAILED_TO_GET_DATA+" "+error.code,"error",true)
}
  setLoading(false)
}, [])

  function checkForChanges(){

    if((invoicePaymentInstructionsEmailLive!==invoicePaymentInstructionsEmailBefore)||
    (invoicePaymentInstructionsChequesPayableLive!==invoicePaymentInstructionsChequesPayableBefore)||
    (invoicePaymentInstructionsBankTransferLive!==invoicePaymentInstructionsBankTransferBefore)||
    (invoicePaymentInstructionsOtherLive!==invoicePaymentInstructionsOtherBefore))
    {
      props.setSaveState(true);
    }
    else
    {
      props.setSaveState(false);
    }
  }




  const classes = useStyles();

  const [error, setError] = useState("")

  function handleSaveData(){
 
    setQuery()
    writeUserData()
 
  }


function enterKeyDown(val){
  if (val && props.currentSaveState) {
    handleSaveData();
    }
}

  const updateText = (e)=> {

    switch(e.target.id) {
      case "invoicePaymentInstructionsEmail":
        setinvoicePaymentInstructionsEmail(e.target.value);
        invoicePaymentInstructionsEmailLive = e.target.value;
      break;
      case "invoicePaymentInstructionsChequesPayable":
        setinvoicePaymentInstructionsChequesPayable(e.target.value);
        invoicePaymentInstructionsOtherLive = e.target.value;
        break;
      case "invoicePaymentInstructionsBankTransfer":
        setinvoicePaymentInstructionsBankTransfer(e.target.value);
        invoicePaymentInstructionsBankTransferLive = e.target.value;
        break;
      case "invoicePaymentInstructionsOther":
        setinvoicePaymentInstructionsOther(e.target.value);
        invoicePaymentInstructionsOtherLive = e.target.value;
        break;
    }

    checkForChanges();
  };




  return (
    <>

<GeneralViewContainer maxWidth="lg">
      <Grid container spacing={1}>

        <Grid item xs={12}>
        <Typography variant="h5" component="h5">{CONST_PAYMENT_INSTRUCTIONS.TITLE}</Typography>
        </Grid>

        <Grid item xs={12}>
        <Box borderTop={1} borderColor="primary.main">
        </Box>
        </Grid>


  <Grid item xs={12}>
      <Tooltip title={CONST_PAYMENT_INSTRUCTIONS.EMAIL_TITLE}>
  <CustomTextField disabled={notEmpty(error)} updateText={updateText}  id="invoicePaymentInstructionsEmail" label={CONST_PAYMENT_INSTRUCTIONS.EMAIL_LABEL} value={invoicePaymentInstructionsEmail} enterKeyDown={enterKeyDown}/>
  </Tooltip>
  </Grid>


  <Grid item xs={12}>
      <Tooltip title={CONST_PAYMENT_INSTRUCTIONS.CHEQUES_PAYABLE_TITLE}>
  <CustomTextField disabled={notEmpty(error)} updateText={updateText}  id="invoicePaymentInstructionsChequesPayable" label={CONST_PAYMENT_INSTRUCTIONS.CHEQUES_PAYABLE_LABEL} value={invoicePaymentInstructionsChequesPayable} enterKeyDown={enterKeyDown}/>
  </Tooltip>
  </Grid>



      <Grid item xs={12}>
      <Tooltip title={CONST_PAYMENT_INSTRUCTIONS.BANK_TRANSFER_TITLE}>
  <CustomTextField rows={3} multiline={true} disabled={notEmpty(error)} updateText={updateText} id="invoicePaymentInstructionsBankTransfer" label={CONST_PAYMENT_INSTRUCTIONS.BANK_TRANSFER_LABEL} placeholder={CONST_PAYMENT_INSTRUCTIONS.BANK_TRANSFER_PLACEHOLDER} value={invoicePaymentInstructionsBankTransfer} enterKeyDown={enterKeyDown}/>
  </Tooltip>

  </Grid>


  <Grid item xs={12}>
      <Tooltip title={CONST_PAYMENT_INSTRUCTIONS.OTHER_TITLE}>
  <CustomTextField disabled={notEmpty(error)} updateText={updateText} id="invoicePaymentInstructionsOther" label={CONST_PAYMENT_INSTRUCTIONS.OTHER_LABEL} value={invoicePaymentInstructionsOther} enterKeyDown={enterKeyDown}/>
  </Tooltip>

  </Grid>
      
    </Grid>
    </GeneralViewContainer>

    </>
  )
}
